// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-box__customer-support[data-v-0b3f8854]{background-color:#4fb262;border-radius:.2em 0 0 .2em;bottom:20px;color:#fff;cursor:pointer;font-size:24px;height:32px;padding:4px 6px;position:fixed;right:0;transition:1s;width:36px;z-index:10}.mp-box__customer-support.hidden[data-v-0b3f8854]{right:-40px;transition:1s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
